export class AdminIdeasOpinionsDeleteRequest {
  ideaId!: string
  opinionId!: string
}
